
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import MrhRoomDetail from "@/components/MrhRoomDetail.vue";
    import ComingSoon from "@/components/ComingSoon.vue";
    import GuaranteeDescription from "@/components/GuaranteeDescription.vue";
    import ThankYou from "@/components/ThankYou.vue";
    import NoComparisonModalMessage from "./NoComparisonModalMessage.vue";
    import HealthSurvey from './HealthSurvey.vue';
    import SplashMessage from './SplashMessage.vue';

    @Component(
        {
            components: {
                HealthSurvey,
                ThankYou,
                MrhRoomDetail,
                ComingSoon,
                GuaranteeDescription,
                NoComparisonModalMessage,
                SplashMessage

            },
        })
    export default class Modal extends Vue {
    };
